import { LaunchDarklyContext } from '@afterpaytouch/feature'
import React, { createContext, ReactElement, ReactNode, useCallback, useContext, useState } from 'react'
import { shallowEqual } from 'react-redux'
import { clearFeatureFlags, setFeatureFlagState, useAppDispatch, useAppSelector } from '../state'
import { getUserContext } from '../utils/object'

interface CheckoutLaunchDarklyContextProps {
  children?: ReactNode
}

const LaunchDarklyIdentityReadyContext = createContext(false)

export const useLaunchDarklyIdentityReady = (): boolean => useContext(LaunchDarklyIdentityReadyContext)

export const CheckoutLaunchDarklyContext = ({ children }: CheckoutLaunchDarklyContextProps): ReactElement => {
  const dispatch = useAppDispatch()
  const userProps = useAppSelector(getUserContext, shallowEqual)
  const [identityReady, setIdentityReady] = useState(false)

  const handleLoad = useCallback((): void => {
    setIdentityReady(false)
    dispatch(setFeatureFlagState(false))
    dispatch(clearFeatureFlags())
  }, [dispatch])

  const handleDone = useCallback((): void => {
    dispatch(setFeatureFlagState(true))
    setIdentityReady(true)
  }, [dispatch])

  return (
    <LaunchDarklyContext userProps={userProps} onLoad={handleLoad} onDone={handleDone}>
      <LaunchDarklyIdentityReadyContext.Provider value={identityReady}>{children}</LaunchDarklyIdentityReadyContext.Provider>
    </LaunchDarklyContext>
  )
}
